module.exports = __webpack_public_path__ + "img/mobile/General/stest@2x.png?0.0.53";